<div class="flex-column gap">
    <app-card [title]="headerTitle()">
        <ng-template #content>
            <div class="flex gap">
                <app-select-input
                    [id]="'groupId'"
                    [form]="form"
                    class="flex-1 w-full"
                    [label]="prefix + 'fields.group'"
                    [staticOptions]="store.groupOptions()"
                    [labelKey]="'name'"
                    [valueKey]="'id'"
                ></app-select-input>
                <app-date-input [form]="form" class="flex-1" [prefix]="prefix" id="validFrom"></app-date-input>
                <app-date-input [form]="form" class="flex-1" [prefix]="prefix" id="validTo"
                    [showTime]="true"></app-date-input>
                @if (type === ServiceGroupEnum.SOCIAL_TARGET) {
                    <app-check-input
                        [form]="form"
                        [prefix]="prefix"
                        id="primary"
                    ></app-check-input>
                }
            </div>

            <div class="flex gap justify-content-end pt-4">
                @if (form.value.id) {
                    <app-cancel-button (clickEvent)="form.reset()"></app-cancel-button>
                }
                <app-save-button
                    [disabled]="form.untouched"
                    [label]="(form.value.id ? 'common.update' : 'common.assign')"
                    (clickEvent)="submit()"
                ></app-save-button>
            </div>
        </ng-template>
    </app-card>

    <app-card-table
        [gridData]="store.data.getFolderGroups()"
        [refreshCallback]="store.api.getFolderGroups"
        [additionalFilter]="additionalFilters()"
        [tableTitle]="'folder.groups.assignedGroups'"
        [columns]="columns"
        [translatePrefix]="prefix"
        [hideCheckboxes]="true"
        (detailCallback)="updateGroup($event)"
        (deleteCallbackWithEvent)="deleteGroup($event)"
    >
        <ng-template pTemplate="group" let-data="data">
            {{ data.name }}
        </ng-template>
    </app-card-table>
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-cancel-button label="common.close" (clickEvent)="dialogRef.close()"></app-cancel-button>
</div>
